<template>
  <div class="accOverview">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="basicInfo">
          <div class="title">
            <img src="@/assets/images/index/jbxx.png"><span>基本信息</span>
            <p>(实名资料无法修改，如需修改联系客服）</p>
          </div>
          <skeleton :loading="accountInfo === ''" :row="3" style="padding: .35rem 0.15rem;">
            <div class="infoCon">
              <ul>
                <li>
                  <p>账户名</p>
                  <span>{{ accountInfo.chineseName }}</span>
                </li>
                <li>
                  <p>证件类型</p>
                  <span>{{ accountInfo.idDocument }}</span>
                </li>
                <li>
                  <p>手机号码</p>
                  <span v-if="accountInfo.mobilePhone">{{
                    accountInfo.mobilePhone.replace(
                      /^(\d{3})\d*(\d{4})$/,
                      '$1 **** $2'
                    )
                  }}</span>
                </li>
                <li>
                  <p>国籍</p>
                  <span>{{ accountInfo.nationality }}</span>
                </li>
                <li>
                  <p>证件号码</p>
                  <span v-if="accountInfo.idDocumentNumber && accountInfo.idDocumentNumber !== 'TEST1693844836539' && !accountInfo.idDocumentNumber.startsWith('NOID')">{{
                    accountInfo.idDocumentNumber.replace(
                      /^(\d{8})\d*(\d{4})$/,
                      '$1 **** $2'
                    )
                  }}
                  </span>
                  <button v-else class="edit" @click="goToAccUpdatePersonalData">
                    <img src="@/assets/images/edit.svg">
                  </button>
                </li>
                <template v-if="!isLegacyPlaceholderEmail">
                  <li
                    class="email-row"
                    :class="{
                      'is-missing': emailState.emailStatus === 'MISSING',
                      'has-inline-email-state': isEmailPending || emailState.emailStatus === 'VERIFIED'
                    }"
                  >
                    <p>电邮地址</p>
                    <div class="email-summary">
                      <div
                        v-if="isEmailPending"
                        class="email-pending-inline"
                      >
                        <span class="email-pending-status">待验证</span>
                        <span class="email-pending-address">
                          {{ pendingEmailDisplayValue }}
                        </span>
                        <button
                          type="button"
                          :disabled="emailStatusRefreshing"
                          :aria-label="emailStatusRefreshing ? '正在更新电邮地址状态' : '继续验证'"
                          @click="openPendingEmailSheet"
                        >
                          <span
                            v-if="emailStatusRefreshing"
                            class="email-status-spinner"
                            aria-hidden="true"
                          />
                          <template v-else>继续验证</template>
                        </button>
                      </div>
                      <div
                        v-else-if="emailState.emailStatus === 'VERIFIED'"
                        class="email-verified-inline"
                      >
                        <span class="email-status is-verified">已绑定</span>
                        <span
                          class="email-verified-address"
                          :title="emailState.activeEmail || emailDisplayValue"
                        >{{ emailDisplayValue }}</span>
                        <button
                          type="button"
                          class="email-action"
                          @click="openEmailSheet"
                        >修改</button>
                      </div>
                      <button
                        v-if="!isEmailPending && emailState.emailStatus !== 'VERIFIED'"
                        type="button"
                        class="email-action"
                        @click="openEmailSheet"
                      >添加</button>
                    </div>
                  </li>
                  <li
                    class="email-helper-row"
                    :class="{ 'is-missing': emailState.emailStatus === 'MISSING' }"
                  >
                    <span v-if="isEmailPending">
                      验证邮件已发送，请前往邮箱激活
                    </span>
                    <span v-else-if="emailState.emailStatus === 'MISSING'">
                      提示: 绑定后可开启按金不足/交易通知/存取款提示
                    </span>
                    <span v-else>
                      您可开启按金不足/交易通知/存取款提示
                    </span>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <p>电邮地址</p>
                    <span>{{ accountInfo.email }}</span>
                  </li>
                  <li style="font-size: .26rem;color:#AE0000">
                    若显示为systemfxservice@outlook.com，表示原注册的电邮地址不正确或拒收状态，如有需要您可聯系客服查詢
                  </li>
                </template>
              </ul>
            </div>
          </skeleton>
        </div>
        <div class="basicInfo">
          <div class="title">
            <img src="@/assets/images/index/jyzh.png"><span>交易账户</span>
            <p>(您的名下共有{{ accTradeInfoList.length }}个交易账户）</p>
          </div>
          <skeleton :row="3" :loading="accTradeInfoList === ''" style="padding: .35rem 0.15rem;">
            <div class="infoCon">
              <ul>
                <li v-if="mt5Enabled" class="header">
                  <p>
                    交易平台
                  </p>
                  <div class="header-group">
                    <p>CFD</p>
                    <p>MT5</p>
                  </div>
                </li>
                <li>
                  <p>账户</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">{{ account.accountNo
                    }}</span>
                    <a v-if="mt5Enabled && accTradeInfoList.length < 2" @click="goToAddMT5CheckPassword">尚未开通</a>
                  </div>
                </li>
                <li>
                  <p>账户币种</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">{{ account.currency
                    }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>级别</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">{{ account.accountLevelName }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>状态</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">{{ account.accountStatusName
                    }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>账户余额</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">${{ account.balance
                    }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>占用资金</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">${{ account.margin }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>可用资金</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">${{ account.freemargin
                    }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
                <li>
                  <p>可取资金</p>
                  <div class="body-group">
                    <span v-for="account in accTradeInfoList" :key="account.accountGroupId">${{
                      account.withdrawableAmount }}</span>
                    <span v-if="mt5Enabled && accTradeInfoList.length == 1" />
                  </div>
                </li>
              </ul>
            </div>
          </skeleton>
        </div>
        <div class="social-media-acc">
          <div class="title">
            <img src="@/assets/images/social/wechat.png" alt="social"><span>社交账号</span>
          </div>
          <skeleton :row="3" :loading="accTradeInfoList === ''" style="padding: .35rem 0.15rem;">
            <div class="infoCon">
              <ul>
                <li>
                  <p>微信账号</p>
                  <span
                    v-if="accTradeInfoList[0] && accTradeInfoList[0].wechatId"
                  >
                    {{
                      accTradeInfoList[0].wechatId.slice(0, 3) +
                        '****' +
                        accTradeInfoList[0].wechatId.slice(3 + 4)
                    }}
                  </span>
                  <router-link v-else to="/home/addWeChat">
                    <span>点击添加</span>
                  </router-link>
                </li>
                <li>
                  <p>电报账号</p>
                  <span v-if="accTradeInfoList[0] && accTradeInfoList[0].telegramId">
                    {{
                      accTradeInfoList[0].telegramId.slice(0, 3) +
                        '****' +
                        accTradeInfoList[0].telegramId.slice(3 + 4)
                    }}
                  </span>
                  <router-link v-else to="/home/addTelegram">
                    <span>点击添加</span>
                  </router-link>
                </li>
                <li>
                  <p>X 账号</p>
                  <span v-if="accTradeInfoList[0] && accTradeInfoList[0].twitterId">
                    {{
                      accTradeInfoList[0].twitterId.slice(0, 3) +
                        '****' +
                        accTradeInfoList[0].twitterId.slice(3 + 4)
                    }}
                  </span>
                  <router-link v-else to="/home/addX">
                    <span>点击添加</span>
                  </router-link>
                </li>
                <li>
                  <p>钉钉账号</p>
                  <span v-if="accTradeInfoList[0] && accTradeInfoList[0].dingtalkId">
                    {{
                      accTradeInfoList[0].dingtalkId.slice(0, 3) +
                        '****' +
                        accTradeInfoList[0].dingtalkId.slice(3 + 4)
                    }}
                  </span>
                  <router-link v-else to="/home/addDingTalk">
                    <span>点击添加</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </skeleton>
        </div>
      </div>
    </div>
    <Chat />
    <EmailChangeSheet
      v-model="showEmailSheet"
      :email-state="emailState"
      :gts2-customer-id="gts2CustomerId"
      @account-info-refreshed="handleAccountInfoRefreshed"
      @close="handleEmailSheetClose"
      @state-changed="handleEmailStateChanged"
    />
  </div>
</template>

<script>
require('@/assets/css/accOverview.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import EmailChangeSheet from '@/view/module/EmailChangeSheet.vue'
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { Skeleton } from 'vant'
import { isMT5Enabled } from '@/utils/helper'
export default {
  name: 'AccOverview',
  components: { Header, Chat, EmailChangeSheet, Skeleton },
  data() {
    return {
      title: '账户总览',
      rightContent: 'isNo',
      accountInfo: '',
      accTradeInfoList: '',
      showEmailSheet: false,
      emailStatusRefreshing: false,
      emailState: {
        emailStatus: 'MISSING',
        originalEmail: '',
        activeEmail: '',
        activeEmailMasked: '',
        pendingChange: null,
        expiredChange: null
      },
      mt5Enabled: isMT5Enabled()
    }
  },
  computed: {
    ...mapState(['gts2CustomerId', 'pageType']),
    isLegacyPlaceholderEmail() {
      return String(this.accountInfo && this.accountInfo.email || '')
        .trim()
        .toLowerCase() === 'systemfxservice@outlook.com'
    },
    emailDisplayValue() {
      if (this.emailState.emailStatus === 'MISSING') return '尚未添加'
      return this.emailState.activeEmailMasked || this.maskEmail(this.emailState.activeEmail)
    },
    isEmailPending() {
      return Boolean(this.emailState.pendingChange) ||
        this.emailState.emailStatus === 'UNVERIFIED'
    },
    pendingEmailDisplayValue() {
      const pending = this.emailState.pendingChange
      if (pending) {
        return pending.maskedEmail || this.maskEmail(pending.email)
      }
      return this.emailDisplayValue
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    if (this.pageType == 'app') this.autofocus()
    this.AccTradeInfo()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    if (this.pageType == 'app') this.autofocus()
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    autofocus() {
      const isIOS = !!navigator.userAgent.match(
        /\(i[^;]+;( U;)? CPU.+Mac OS X/
      )
      // 软键盘弹出的事件处理
      document.body.addEventListener('focusin', () => {
        if (isIOS) {
          window.scrollTo(0, 0)
        }
      })
      // 软键盘收起的事件处理
      document.body.addEventListener('focusout', () => {
        if (isIOS) {
          window.scrollTo(0, 0)
        }
      })
    },
    AccTradeInfo() {
      api.getAccTradeInfo(this.gts2CustomerId).then((res) => {
        if (res.data.code == 200) {
          this.applyAccountInfo(res.data.data.accountInfo)
          if (this.mt5Enabled) {
            this.accTradeInfoList = res.data.data.accTradeInfoList
          } else {
            this.accTradeInfoList = [res.data.data.accTradeInfoList.find(account => account.platform == 'GTS2')]
          }
        }
      })
    },
    isMissingEmail(email) {
      const normalized = String(email || '').trim().toLowerCase()
      return normalized === '' ||
        normalized === 'systemfxservice@outlook.com' ||
        normalized === 'realemail'
    },
    maskEmail(email) {
      const normalized = String(email || '').trim()
      const separatorIndex = normalized.indexOf('@')
      if (separatorIndex <= 0) return normalized
      const localPart = normalized.slice(0, separatorIndex)
      const domain = normalized.slice(separatorIndex + 1)
      const visible = localPart.length <= 2 ? localPart.slice(0, 1) : localPart.slice(0, 2)
      return `${visible}***@${domain}`
    },
    buildApiEmailState(accountInfo) {
      const email = accountInfo && accountInfo.email
      const emailNew = accountInfo && accountInfo.emailNew
      const numericStatus = Number(accountInfo && accountInfo.emailStatus)
      const hasCurrentEmail = !this.isMissingEmail(email)
      const hasPendingEmail = !this.isMissingEmail(emailNew)
      const previousPending = this.emailState && this.emailState.pendingChange
      const currentEmail = this.normalizeEmail(email)
      const previousEmail = this.normalizeEmail(previousPending && previousPending.email)
      const previousOriginalEmail = this.normalizeEmail(
        previousPending && previousPending.originalEmail !== undefined
          ? previousPending.originalEmail
          : this.emailState && this.emailState.originalEmail
      )
      const expiredChange = previousPending &&
        numericStatus === 1 &&
        !hasPendingEmail &&
        currentEmail === previousOriginalEmail &&
        currentEmail !== previousEmail
        ? previousPending
        : null
      if (numericStatus === 0 && hasPendingEmail) {
        return {
          emailStatus: hasCurrentEmail ? 'VERIFIED' : 'MISSING',
          originalEmail: email || '',
          activeEmail: hasCurrentEmail ? email : '',
          activeEmailMasked: hasCurrentEmail ? this.maskEmail(email) : '',
          pendingChange: {
            email: emailNew,
            originalEmail: email || '',
            maskedEmail: this.maskEmail(emailNew),
            resendAvailableAt: Date.now()
          },
          expiredChange: null
        }
      }

      if (numericStatus === -1 || !hasCurrentEmail) {
        return {
          emailStatus: 'MISSING',
          originalEmail: email || '',
          activeEmail: '',
          activeEmailMasked: '',
          pendingChange: null,
          expiredChange
        }
      }
      return {
        emailStatus: numericStatus === 1 ? 'VERIFIED' : 'UNVERIFIED',
        originalEmail: email || '',
        activeEmail: email,
        activeEmailMasked: this.maskEmail(email),
        pendingChange: null,
        expiredChange
      }
    },
    applyAccountInfo(accountInfo) {
      if (!accountInfo) return
      this.accountInfo = accountInfo
      this.emailState = this.buildApiEmailState(accountInfo)
    },
    handleAccountInfoRefreshed(accountInfo) {
      this.applyAccountInfo(accountInfo)
    },
    openEmailSheet() {
      this.showEmailSheet = true
    },
    async openPendingEmailSheet() {
      const didRefresh = await this.refreshAccountEmailState()
      if (
        !didRefresh ||
        this.isEmailPending ||
        this.emailState.expiredChange
      ) this.openEmailSheet()
    },
    handleEmailSheetClose() {
      if (this.emailState.expiredChange) {
        this.emailState = Object.assign({}, this.emailState, {
          expiredChange: null
        })
      }
      this.refreshAccountEmailState()
    },
    async refreshAccountEmailState() {
      if (this.emailStatusRefreshing) return false
      this.emailStatusRefreshing = true
      try {
        const response = await api.getAccTradeInfo(this.gts2CustomerId)
        if (!response || !response.data || response.data.code != 200) return false
        const accountInfo = response.data.data && response.data.data.accountInfo
        if (!accountInfo) return false
        this.applyAccountInfo(accountInfo)
        return true
      } catch {
        return false
      } finally {
        this.emailStatusRefreshing = false
      }
    },
    handleEmailStateChanged(nextState) {
      if (!nextState || typeof nextState.emailStatus !== 'string') return
      this.emailState = nextState
    },
    normalizeEmail(email) {
      return String(email || '').trim().toLowerCase()
    },
    goToAddMT5CheckPassword() {
      this.$router.push({ path: '/home/addMT5CheckPassword' })
    },
    goToAccUpdatePersonalData() {
      this.$router.push({ path: '/home/accUpdatePersonalData', query: { from: this.$route.path }})
    }
  }
}
</script>
